<template>
  <div class="msg_container">
    <div class="dialog_tit" slot="title">付款二维码</div>

    <img
        class="gender"
        src="../../assets/img/home/pay.jpg"
        style="margin-top:15px;width: 105px; height: 105px; float: left!important;"
    />
/*    <img style="height: 200px;width: 160px;" src="../../assets/img/home/pay.jpg" width="360" border="0"/>*/
  </div>
</template>
<script>
import { getMsgDetail } from "../../assets/js/api.js";
export default {
  data() {
    return {
      msgDetail: "",
    };
  },
  mounted() {
    // console.log(this.$route.query);
    this.id = this.$route.query.id;
    this.getMsgDetail();
  },
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>

